module.exports = __webpack_public_path__ + "img/kyc.3c6395ac.svg";